import { apiClient } from './api';
import { API_ENDPOINTS } from '../constants';

export const licenseTypeService = {
  async getLicenseTypes(filters = {}) {
    const params = new URLSearchParams();
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.LICENSE_TYPES}?${queryString}` : API_ENDPOINTS.LICENSE_TYPES;
    
    const response = await apiClient.get(endpoint);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response || [];
  },

  async getLicenseType(id) {
    const response = await apiClient.get(API_ENDPOINTS.LICENSE_TYPE_DETAIL(id));
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async createLicenseType(data) {
    console.log('Enviando datos al API:', data);
    console.log('Endpoint:', API_ENDPOINTS.LICENSE_TYPES);
    
    const response = await apiClient.post(API_ENDPOINTS.LICENSE_TYPES, data);
    
    console.log('Respuesta del API:', response);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async updateLicenseType(id, data) {
    const response = await apiClient.put(API_ENDPOINTS.LICENSE_TYPE_DETAIL(id), data);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async deleteLicenseType(id) {
    return apiClient.delete(API_ENDPOINTS.LICENSE_TYPE_DETAIL(id));
  },

  async toggleLicenseTypeStatus(id) {
    const response = await apiClient.patch(`${API_ENDPOINTS.LICENSE_TYPE_DETAIL(id)}/toggle-status/`);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  }
};
